// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202512190803/js/" + chunkId + "." + {"44":"78f7ef47","225":"ae157c13","481":"00632fcc","486":"73ea0c2e","770":"366fbf2e"}[chunkId] + ".0.8580059431539111.chunk.js";
};